import React from 'react';
import PropTypes from 'prop-types';

// Styles
import styles from './styles/CartUnavailableItem.scss';

const unavailableMap = {
    sold: {
        className: styles.isSold,
        dotClass: styles.isSoldDot,
        dataTn: 'sold',
    },
    onHold: {
        className: styles.isOnHold,
        dotClass: styles.isOnHoldDot,
        dataTn: 'on-hold',
    },
    unavailable: {
        dataTn: 'unavailable',
    },
};

const CartUnavailableItem = ({ type, header, copy }) => {
    const mappedValues = unavailableMap[type] || {};
    const dataTn = `cart-item-${mappedValues.dataTn}`;

    return (
        <div className={`${styles.wrapper} ${mappedValues.className}`}>
            {header && (
                <span className={styles.header}>
                    <span className={mappedValues.dotClass} data-tn={dataTn} />
                    <span>{header}</span>
                </span>
            )}
            {copy && (
                <span className={styles.copy} data-tn={dataTn}>
                    {copy}
                </span>
            )}
        </div>
    );
};

CartUnavailableItem.defaultProps = {
    header: null,
    copy: null,
};

CartUnavailableItem.propTypes = {
    type: PropTypes.oneOf(['sold', 'onHold', 'unavailable']),
    header: PropTypes.node,
    copy: PropTypes.node,
};

export default CartUnavailableItem;
